import getters from './getters';
import mutations from './mutations';
import payload from '~/config/sharedEnv';
export var state = function state() {
  return {
    payload: payload
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations
};